import { render, staticRenderFns } from "./Page9.vue?vue&type=template&id=28c74110&scoped=true&"
import script from "./Page9.vue?vue&type=script&lang=js&"
export * from "./Page9.vue?vue&type=script&lang=js&"
import style0 from "./Page9.vue?vue&type=style&index=0&id=28c74110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c74110",
  null
  
)

export default component.exports